
export default {
  name: 'FixedService',
  methods: {
    // 点击客服
    handleClickService() {
      window.zytrack && window.zytrack('custom', 'HomePage_CustomerService')
      window.open('https://qiyukf.com/client?k=24ada582654049dffe310a772b0c0db1', '_blank')
    },
  },
}
